export interface PlmTaskVisibility {
  status?: string;
  scheduledStart?: number | null;
  scheduledEnd?: number | null;
  startedAt?: number | null;
  endedAt?: number | null;
}

export function hasActiveOrPendingPlmTasks(
  tasks: PlmTaskVisibility[],
  currentTimestamp = Date.now(),
): boolean {
  return tasks.some((task) => {
    const isCurrent =
      task.status === 'active' &&
      !!task.startedAt &&
      task.startedAt <= currentTimestamp &&
      (!task.endedAt || task.endedAt > currentTimestamp);

    const isScheduled =
      task.status === 'scheduled' &&
      !!task.scheduledStart &&
      task.scheduledStart > currentTimestamp;

    return isCurrent || isScheduled;
  });
}
